module.exports = __webpack_public_path__ + "img/tip-icon.1ab86c5f.png";